(() => {
  'use strict';
  const configuration = document.getElementById('theme-config');
  if (!configuration) return;
  const config = JSON.parse(configuration.textContent);
  const root = config.root.replace(/\/?$/, '/');
  const products = new WeakMap();
  let cartBusy = false, scrollQueued = false, toastTimer;
  const notify = message => {
    const toast = document.getElementById('toast');
    toast.textContent = message; toast.hidden = false;
    clearTimeout(toastTimer); toastTimer = setTimeout(() => { toast.hidden = true; }, 4500);
  };
  function open(dialog) {
    if (!dialog || dialog.open) return;
    if (dialog.dataset.imageUrl) {
      const image = dialog.querySelector('img');
      if (!image.src) image.src = dialog.dataset.imageUrl;
      image.hidden = false;
    }
    dialog.showModal();
  }
  async function request(path, body) {
    const response = await fetch(root + path, { method: body ? 'POST' : 'GET', credentials: 'same-origin', headers: {'Accept':'application/json', ...(body ? {'Content-Type':'application/json'} : {})}, ...(body ? {body:JSON.stringify(body)} : {}) });
    const data = await response.json();
    if (!response.ok) throw new Error(typeof data.description === 'string' ? data.description : typeof data.message === 'string' ? data.message : config.strings.error);
    return data;
  }
  function replaceCart(html, show) {
    const parsed = new DOMParser().parseFromString(html, 'text/html');
    const panel = parsed.getElementById('shopify-section-cart-panel');
    const current = document.getElementById('shopify-section-cart-panel');
    if (!panel || !current) throw new Error(config.strings.error);
    const wasOpen = current.querySelector('dialog').open;
    if (wasOpen) current.querySelector('dialog').close();
    current.replaceWith(panel);
    const count = Number(panel.querySelector('dialog').dataset.count);
    document.querySelectorAll('[data-cart-count]').forEach(badge => {badge.textContent=count; badge.hidden=count===0;});
    if (show || wasOpen) open(panel.querySelector('dialog'));
  }
  async function refreshCart(show, sections) {
    if (sections && sections['cart-panel']) {replaceCart(sections['cart-panel'],show); return;}
    const response = await fetch(config.cartUrl + '?section_id=cart-panel', {credentials:'same-origin',cache:'no-store'});
    if (!response.ok) throw new Error(config.strings.error);
    replaceCart(await response.text(),show);
  }
  function setBusy(form,busy) {
    form.setAttribute('aria-busy',String(busy));
    form.querySelectorAll('button,select,input').forEach(input => {input.disabled = busy;});
    if (!busy && form.dataset.unavailable==='true') form.querySelectorAll('[data-add],[data-buy]').forEach(button => {button.disabled=true;});
    if(!busy)products.get(form.closest('[data-product-section]'))?.updateBundle();
  }
  function checkout() {
    const form = document.createElement('form'); form.method='post'; form.action=config.cartUrl;
    const input=document.createElement('input'); input.type='hidden'; input.name='checkout'; input.value='1';
    form.append(input); document.body.append(form); form.submit();
  }
  async function addProduct(form,buy) {
    if (cartBusy || form.dataset.unavailable==='true' || !form.reportValidity()) return;
    const error=form.querySelector('[data-product-error]'); error.textContent='';
    const id=Number(form.querySelector('[name=id]').value), quantity=Number(form.querySelector('[name=quantity]').value);
    if (!Number.isInteger(quantity) || quantity<1) return;
    cartBusy=true; setBusy(form,true);
    let added=false;
    try {
      const data=await request('cart/add.js',{items:[{id,quantity}],sections:['cart-panel'],sections_url:location.pathname});
      added=true;
      if (buy) {checkout(); return;}
      await refreshCart(true,data.sections);
    } catch (failure) {
      if (added) {location.assign(config.cartUrl); return;}
      error.textContent=failure.message || config.strings.error;
      try {await refreshCart(false);} catch {}
    } finally {cartBusy=false; setBusy(form,false);}
  }
  async function changeCart(id,quantity) {
    if (cartBusy || !Number.isInteger(quantity) || quantity<0) return;
    cartBusy=true;
    const dialog=document.getElementById('cart-dialog'); dialog.setAttribute('aria-busy','true');
    dialog.querySelectorAll('button,input').forEach(input=>{input.disabled=true;});
    let changed=false;
    try {
      const data=await request('cart/change.js',{id,quantity,sections:['cart-panel'],sections_url:location.pathname});
      changed=true; await refreshCart(true,data.sections);
    } catch (failure) {
      if(changed){location.assign(config.cartUrl);return;}
      notify(failure.message || config.strings.error);
      try {await refreshCart(true);} catch {}
    } finally {
      cartBusy=false; const current=document.getElementById('cart-dialog'); current.removeAttribute('aria-busy');
      current.querySelectorAll('button,input').forEach(input=>{input.disabled=false;});
    }
  }
  function initializeProduct(section) {
    if(products.has(section))return;
    const form=section.querySelector('.product-form');
    const variantsNode=document.querySelector(`[data-variants-for="${section.dataset.sectionId}"]`);
    if(!form || !variantsNode)return;
    const variants=JSON.parse(variantsNode.textContent), image=section.querySelector('.product-image');
    const original={src:image.getAttribute('src'),srcset:image.getAttribute('srcset'),sizes:image.getAttribute('sizes')};
    const sticky=document.querySelector(`[data-sticky-for="${section.dataset.sectionId}"]`);
    const bundlePercent=Number(section.dataset.bundlePercent)||0;
    const money=new Intl.NumberFormat(config.locale||'fr',{style:'currency',currency:config.currency||'EUR'});
    let activeVariant;
    function updateBundle() {
      if(!activeVariant || !bundlePercent)return;
      const quantity=form.querySelector('[name=quantity]');
      const unit=Math.round(activeVariant.price*(100-bundlePercent)/100);
      const count=Number(quantity.value)||activeVariant.min;
      const total=count>=2?unit*count:activeVariant.price*count;
      const max=quantity.max?Number(quantity.max):Infinity;
      form.querySelectorAll('[data-bundle-choice]').forEach(radio=>{
        const amount=Number(radio.value);
        const valid=activeVariant.available && amount>=activeVariant.min && amount<=max && (amount-activeVariant.min)%activeVariant.step===0;
        radio.disabled=!valid;
        radio.checked=count===amount;
        radio.closest('[data-bundle-card]').classList.toggle('is-selected',radio.checked);
        radio.closest('[data-bundle-card]').classList.toggle('is-unavailable',!valid);
      });
      form.querySelector('[data-bundle-total="1"]').innerHTML=activeVariant.money;
      form.querySelector('[data-bundle-total="2"]').textContent=money.format(unit*2/100);
      form.querySelector('[data-bundle-base]').textContent=money.format(activeVariant.price*2/100);
      form.querySelector('[data-bundle-unit]').textContent=config.bundleStrings.perItem.replace('__AMOUNT__',money.format(unit/100));
      const label=activeVariant.available?(count===1?config.bundleStrings.single:count===2?config.bundleStrings.duo:config.bundleStrings.many.replace('__QUANTITY__',String(count))):config.strings.soldOut;
      form.querySelector('[data-button-label]').textContent=label;
      if(sticky){sticky.querySelector('[data-sticky-price]').textContent=money.format(total/100);sticky.querySelector('[data-sticky-label]').textContent=label;}
    }
    function setImage(src) {
      if(src){image.removeAttribute('srcset');image.removeAttribute('sizes');image.src=src;}
      else {image.src=original.src;if(original.srcset)image.setAttribute('srcset',original.srcset);if(original.sizes)image.setAttribute('sizes',original.sizes);}
      const modal=document.getElementById('image-'+section.dataset.sectionId);
      modal.dataset.imageUrl=src || original.src;
      const zoom=modal.querySelector('img'); if(zoom.getAttribute('src'))zoom.src=src || original.src;
    }
    function updateVariant(userChange=false) {
      const variant=variants.find(v=>String(v.id)===form.querySelector('[name=id]').value); if(!variant)return;activeVariant=variant;
      const price=section.querySelector('[data-product-price]');price.replaceChildren();
      const current=document.createElement('strong');current.innerHTML=variant.money;price.append(current);
      if(variant.compare>variant.price){const compare=document.createElement('s');compare.innerHTML=variant.compareMoney;const saving=document.createElement('span');saving.className='save-badge';saving.textContent=variant.saving;price.append(compare,saving);}
      const status=section.querySelector('[data-stock-status]');status.replaceChildren();
      const dot=document.createElement('span');dot.className='stock-dot';dot.setAttribute('aria-hidden','true');
      let message=config.strings.available;
      if(!variant.available){dot.classList.add('out');message=config.strings.out;}
      else if(variant.tracked && variant.policy==='deny' && variant.quantity>0 && variant.quantity<=Number(section.dataset.lowThreshold)){dot.classList.add('low');message=config.strings.lowStock.replace('__QUANTITY__',String(variant.quantity));}
      else if(variant.tracked && variant.quantity<=0){message=config.strings.preorder;}
      status.append(dot,document.createTextNode(message));
      const quantity=form.querySelector('[name=quantity]');quantity.min=variant.min;quantity.step=variant.step;
      let max=variant.max;
      if(variant.tracked && variant.policy==='deny' && variant.quantity>0)max=max?Math.min(max,variant.quantity):variant.quantity;
      if(max)quantity.max=max;else quantity.removeAttribute('max');
      if(userChange)quantity.value=variant.min;
      quantity.value=Math.max(variant.min,Math.min(max||Infinity,Number(quantity.value)||variant.min));
      form.dataset.unavailable=String(!variant.available);
      form.querySelector('[data-button-label]').textContent=variant.available?config.strings.add:config.strings.soldOut;
      setBusy(form,false);
      if(sticky){sticky.querySelector('[data-sticky-price]').innerHTML=variant.money;sticky.querySelector('button').disabled=!variant.available;}
      updateBundle();
      if(userChange){setImage(variant.image);if(location.pathname.includes('/products/')){const url=new URL(location.href);url.searchParams.set('variant',variant.id);history.replaceState({},'',url);}}
    }
    const updateSticky=()=>{if(sticky){const bounds=form.querySelector('.purchase-buttons').getBoundingClientRect();sticky.hidden=bounds.top>=0 && bounds.bottom<=window.innerHeight;}};
    products.set(section,{updateSticky,setImage,updateVariant,updateBundle});updateVariant();updateSticky();
    form.addEventListener('change',event=>{if(event.target.matches('[data-variant-select]'))updateVariant(true);if(event.target.matches('[data-bundle-choice]')){form.querySelector('[name=quantity]').value=event.target.value;updateBundle();}if(event.target.matches('[name=quantity]'))updateBundle();});
  }
  const initialize=node=>node.querySelectorAll('[data-product-section]').forEach(initializeProduct);
  const updateSticky=()=>{if(scrollQueued)return;scrollQueued=true;requestAnimationFrame(()=>{document.querySelectorAll('[data-product-section]').forEach(section=>products.get(section)?.updateSticky());scrollQueued=false;});};
  initialize(document);document.addEventListener('shopify:section:load',event=>initialize(event.target));
  document.addEventListener('scroll',updateSticky,{passive:true});window.addEventListener('resize',updateSticky);
  document.addEventListener('click',async event=>{
    const target=event.target;
    const trigger=target.closest('[data-open]');if(trigger){event.preventDefault();open(document.getElementById(trigger.dataset.open));return;}
    const close=target.closest('[data-close]');if(close){close.closest('dialog').close();return;}
    const cart=target.closest('[data-cart-open]');if(cart){event.preventDefault();if(cartBusy)return;try{await refreshCart(true);}catch{location.assign(config.cartUrl);}return;}
    const remove=target.closest('#cart-dialog [data-cart-remove]');if(remove){event.preventDefault();await changeCart(remove.dataset.key,0);return;}
    const increment=target.closest('[data-quantity-step]');if(increment){const input=increment.closest('form').querySelector('[name=quantity]');const min=Number(input.min)||1,step=Number(input.step)||1,max=input.max?Number(input.max):Infinity;input.value=Math.min(max,Math.max(min,(Number(input.value)||min)+Number(increment.dataset.quantityStep)*step));products.get(increment.closest('[data-product-section]'))?.updateBundle();return;}
    const media=target.closest('[data-media-src]');if(media){const section=media.closest('[data-product-section]');products.get(section)?.setImage(media.dataset.mediaSrc);section.querySelectorAll('[data-media-src]').forEach(button=>button.setAttribute('aria-pressed',String(button===media)));return;}
    const sticky=target.closest('[data-sticky-add]');if(sticky){const form=document.querySelector(`[data-section-id="${sticky.dataset.stickyAdd}"] .product-form`);if(form)form.requestSubmit(form.querySelector('[data-add]'));return;}
    if(target.tagName==='DIALOG'){const rect=target.getBoundingClientRect();if(event.clientX<rect.left||event.clientX>rect.right||event.clientY<rect.top||event.clientY>rect.bottom)target.close();}
  });
  document.addEventListener('change',event=>{if(event.target.matches('#cart-dialog [data-cart-quantity]'))changeCart(event.target.dataset.key,Number(event.target.value));if(event.target.matches('[data-sort]'))event.target.form.requestSubmit();});
  document.addEventListener('submit',event=>{if(event.target.matches('.product-form')){event.preventDefault();addProduct(event.target,Boolean(event.submitter?.matches('[data-buy]')));}});
})();
